const config = {
  ENV: "qa"
};
export default config;
